export { MyAdsBulkPromotion } from './MyAdsBulkPromotion';
